/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionQuestProgress
 */
export interface SessionQuestProgress {
    /**
     * 
     * @type {string}
     * @memberof SessionQuestProgress
     */
    questId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionQuestProgress
     */
    questName?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionQuestProgress
     */
    progressMade?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionQuestProgress
     */
    totalRequired?: number;
}

/**
 * Check if a given object implements the SessionQuestProgress interface.
 */
export function instanceOfSessionQuestProgress(value: object): value is SessionQuestProgress {
    return true;
}

export function SessionQuestProgressFromJSON(json: any): SessionQuestProgress {
    return SessionQuestProgressFromJSONTyped(json, false);
}

export function SessionQuestProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionQuestProgress {
    if (json == null) {
        return json;
    }
    return {
        
        'questId': json['questId'] == null ? undefined : json['questId'],
        'questName': json['questName'] == null ? undefined : json['questName'],
        'progressMade': json['progressMade'] == null ? undefined : json['progressMade'],
        'totalRequired': json['totalRequired'] == null ? undefined : json['totalRequired'],
    };
}

export function SessionQuestProgressToJSON(json: any): SessionQuestProgress {
    return SessionQuestProgressToJSONTyped(json, false);
}

export function SessionQuestProgressToJSONTyped(value?: SessionQuestProgress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questId': value['questId'],
        'questName': value['questName'],
        'progressMade': value['progressMade'],
        'totalRequired': value['totalRequired'],
    };
}

